import { useState, useEffect } from 'react';

export const useKambiError = () => {
  const [isKambiError, setIsKambiError] = useState(false);

  useEffect(() => {
    // Timeout para verificar que KambiBC haya cargado correctamente
    const timeoutId = setTimeout(() => {
      const kambiBCElement = document.getElementById('KambiBC');

      if (kambiBCElement && kambiBCElement.firstChild) {
        const firstChildId = kambiBCElement.firstChild.getAttribute('id');

        if (firstChildId !== 'KambiBC-container') {
          window.location.reload();
          // setIsKambiError(true);
        }
      } else {
        // Mostrar overlay para dar opcion de reintentar
        window.location.reload();
        // setIsKambiError(true);
      }
    }, 10000);

    // Limpiar el timeout si el componente se desmonta antes
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    // Si hay un error, revisar constantemente si ya existe el contenedor correcto
    if (!isKambiError) return;

    const checkInterval = setInterval(() => {
      const kambiBCElement = document.getElementById('KambiBC');

      if (kambiBCElement && kambiBCElement.firstChild) {
        const firstChildId = kambiBCElement.firstChild.getAttribute('id');

        if (firstChildId === 'KambiBC-container') {
          // setIsKambiError(false);
        }
      }
    }, 1000); // Verificar cada segundo

    // Limpiar el intervalo si el componente se desmonta o el error se resuelve
    return () => {
      clearInterval(checkInterval);
    };
  }, [isKambiError]);

  return isKambiError;
};
